app.service('notice', function (console, loading, validate, modal, productCardConfig, captchaService) {
	var config;

	function letMeSuccess(){
		attachNotificationCaptcha();
		validate.task('notice',function(form){
			form.addClass('loading');
			letMe($('#notice').val());
		});
	}
	function letMe(email){
		var that=this;
		config=productCardConfig.getData();
		if(!email){
			email=$('#let-me-email').val();
		}
		loading.start();
		$.ajax({
			url:'/productQuestionsNotificationSubscription.ltr',
			data:{
				email:email,
				productId:config.id,
				"g-recaptcha-response": $('#notice-form').find("#g-recaptcha-response").val() || ""
			},
			success:function(html){
				if($('<div>'+html+'</div>').find('form').length){
					modal.generate({
						header: 'Powiadomienie',
						id:'notice-modal',
						content:html,
						callbackOpen:function(){
							letMeSuccess();
						}
					});
				}else{
					modal.alert(html);
				}
			},
			complete:function(){
				loading.stop();
			},
			error:function(){
				modal.alert('Błąd komunikacji, prosimy spróbować później');
			}
		});
	}

	function attachNotificationCaptcha() {
		const $captcha = $('#notice-modal').find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	
	return {
		letMe:letMe
	};
});